import { initWidget } from './widget.js';
window.initWidget = initWidget;
